module.exports = "use App\\Event\\SaleEvent;\n\n//...\n\nif ($form->isSubmitted() && $form->isValid()) {\n    $em = $this->getDoctrine()->getManager();\n    $em->persist($sale);\n\n    $numTickets = $form['numTickets']->getData();\n\n    $this->get('event_dispatcher')\n        ->dispatch(\n            SaleEvent::NAME,\n            new SaleEvent($sale, $movie, $numTickets)\n        );\n\n    $em->flush();\n\n    $this->addFlash(\n        'notice',\n        'Thank you for your sale!'\n    );\n\n    return $this->redirectToRoute('index');\n}"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/pages/code/controller-movie-event.txt
// module id = 631
// module chunks = 246501157640856